<template>
  <div style="height: 100%; width: 1440px;">
    <el-row>
      
      <el-col :span="4.4" style="margin-top:22px;">
        <div style=" color: black;width:100%;" align="right">
          <el-card class="box-card" style="margin-top:2%;border-radius: 8px;" align="right">
            <el-tree :data='treeData' :props="defaultProps" @node-click="nodeClicked" accordion :highlight-current="true">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
            </span>
            </el-tree>
          </el-card>
        </div>
      </el-col>
      <el-col :span="4" style="margin-top:22px;">
        <el-card class="box-card" style="margin-top:2%;border-radius: 8px;max-height:700px;overflow-y:auto;" align="center">
          <div style="padding-top:0.18%;" >
              <div align="center">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
                </el-checkbox>
              </div>
              <!--<div :align="checkBoxAlign">-->
              <div align="left">
                <el-checkbox-group v-model="checkedPvList" @change="handleCheckedPvListChange" border="true">
                  <el-checkbox v-for="(pv1) in pvList" :label="pv1.name" :key="pv1.pvname"  style="color: #000;width:200px;height:39px;line-height: 39px;">
                    <span class="custom-pvlist" slot-scope="{ data }">{{ data }}
                      <!--<span @click.stop style="float:right;" class="yuzhi">
                        <el-dropdown >
                          <span class="el-dropdown-link">
                            <i class="el-icon-caret-bottom el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <span style="margin-left:30px;">min:</span>
                            <el-input class="yuzhiInput" style="width:105px;" v-model="yuzhi[index].yuzhi1" placeholder="min" size="mini"></el-input>
                            <span> ~ </span>
                            <span>max:</span>
                            <el-input class="yuzhiInput" style="width:105px;margin-right:30px;" v-model="yuzhi[index].yuzhi2" placeholder="max" size="mini"></el-input>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </span>-->
                    </span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <!--<el-table 
                :data="pvList.slice(pageSizePV * (currentPagePV-1),pageSizePV * (currentPagePV-1) + 14)"
                style="width:100%">
                <el-table-column
                  type="selection"
                  width="55px">
                </el-table-column>
                <el-table-column
                  label="名称">
                  <template slot-scope="scope">{{scope.row.name}}</template>
                </el-table-column>
              </el-table>
              <el-pagination 
                small
                layout="prev,pager,next"
                :page-count="Math.ceil(pvList.length/pageSizePV)"
                :current-page.sync="currentPagePV"
                @current-change ="currentChangepV"
                :page-size = "pageSizePV">
              </el-pagination>-->
          </div>
        </el-card>
      </el-col>
      <el-col :span="1" style="height:10px;">
        <div><p></p></div>
      </el-col>
     
       <el-dialog title="Data" :visible.sync="dialogTableVisible" width="90%" align="center">
        <div :hidden="dataLoading">
          <i class="el-icon-loading"></i>
        </div>
        <el-row>
          <div align="center" style="color: #000;">
            <el-table :data="gridData" style="color: #000;" align="center">
              <el-table-column v-for="col in checkedPvList" :property="col" :label="col" :key="col" align="center"
                               width="300" header-align="center"></el-table-column>
            </el-table>
          </div>
        </el-row>
        <el-row>
          <el-pagination
            background
            layout="prev, pager, next,jumper"
            :page-count="pageNumber"
            :current-page.sync="currentPage"
            @current-change="pageChange" align="center">
          </el-pagination>
        </el-row>
      </el-dialog>
      <el-dialog title="Statistics" :visible.sync="statisticsDialogTableVisible" align="center">
        <div :hidden="statisticsLoading">
          <i class="el-icon-loading"></i>
        </div>
        <el-table :data="statisticsData">
          <el-table-column property="Pv_Name" label="Pv Name"></el-table-column>
          <el-table-column property="Mean" label="Mean"></el-table-column>
          <el-table-column property="Deviation" label="Deviation"></el-table-column>
          <el-table-column property="RMS" label="RMS"></el-table-column>
          <el-table-column property="Max" label="Max"></el-table-column>
          <el-table-column property="Min" label="Min"></el-table-column>
        </el-table>
      </el-dialog>
      <el-col :span="15" align="center">
        <div class="chartDiv" style=" margin-top: 3%; margin-left: auto; margin-right: auto; width: 100%;"
             align="center" v-loading="chartLoading">
          <highstock :options='options' style="width: 100%;" ref="highcharts"></highstock> 
        </div>
        <div style="margin-top: 1%;">
        <div v-if="false" style="display: inline-block;margin-right: 0.5%;font-size: 14px;">Data Source:</div>
          <el-select v-if="false" v-model="daSourceValue" placeholder="请选择" style="width:150px;" @change="changeDataSource">
            <el-option
            v-for="item in dataSources"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!--<div>
          <div align="center">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox>
          </div>
          <div :align="checkBoxAlign">
            <el-checkbox-group v-model="checkedPvList" @change="handleCheckedPvListChange" border="true">
              <el-checkbox v-for="pv1 in pvList" :label="pv1.name" :key="pv1.pvname" style="color: #000;"><font size=4
                style="font-family: 'Consolas';font-weight: normal; ">{{pv1.name}}</font>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>-->
        <div class="block" style="margin-top: 1%;font-weight: bold;" align="center">
            <el-date-picker
            v-model="value5"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="to"
            start-placeholder="start time"
            end-placeholder="end time"
            align="right"
            style="width:400px;"
          >
          </el-date-picker>
          <div style="display: inline-block;margin-right: 0.5%;font-size: 14px;">Aggregate Type:</div>
          <el-select v-model="ppValue" placeholder="请选择" style="width:150px;"  :disabled = "isDisabled" >
            <el-option
            v-for="item in ppOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-top: 1%" align="center">
          <el-button v-on:click="query" type="primary" style="background-color: #004499; border-color: #004499"
                     :disabled="queryDisabled">Draw Line Chart
          </el-button>
          <el-button v-on:click="showStatistics" type="primary" style="background-color: #004499; border-color: #004499"
                     :disabled="statisticsDisabled">Statistics Data
          </el-button>
          <el-button @click="showData" type="primary" style="background-color: #004499; border-color: #004499"
                     :disabled="dataDisabled">View Data
          </el-button>
          <el-button v-on:click="downloadData" type="primary" style="background-color: #004499; border-color: #004499"
                     :disabled="downloadDisabled">Download Data
          </el-button>
          <el-button v-on:click="liveData" type="primary" style="background-color: #004499; border-color: #004499"
                     :disabled="queryDisabled">Live
          </el-button>
        </div>
        <div style="margin-top: 1%" align="center">
          <div :hidden="switchHidden" style="margin-top: 1%;">
              <el-switch
                active-color="#13ce66"
                inactive-color="#696969"
                active-text="Logarithmic"
                v-model="switchValue1"
                :disabled="switchHidden1"
                @change="changeChartType"
              >
              </el-switch>
              <el-switch
                active-color="#13ce66"
                inactive-color="#696969"
                active-text="Beam Current"
                v-model="switchValue2"
                :disabled="switchHidden2"
                @change="addBeamCurrSeries">
              </el-switch>
              <el-switch
                active-color="#13ce66"
                inactive-color="#696969"
                active-text="Refetch Data at Zoom"
                v-model="switchValue3"
                :disabled="switchHidden3"
                @change="changeSelectType">
              </el-switch>
          </div>
          <div style="width: 30%; margin-top: 10px" :hidden="progressHidden">
            <!--<font>正在下载第{{downloadSeries}}个PV</font>-->
            <!--<font>downloading data of the {{downloadSeries}}st selected record</font>-->
            <!-- <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage">Download Progress</el-progress> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import ChartTime from './chartTime.vue';
  export default {
    name: "historicalcharts",
    components:{
      highcharts:Chart,
      ChartTime,
    },
    watch: {
      // 监听 switchValue3 的变化
      switchValue3(newVal, oldVal) {
        console.log('switchValue3 变化:', oldVal, '->', newVal);
        // 实时处理逻辑
        this.switchValue3 = newVal;
        if(this.switchValue3 === true){
          this.options.xAxis.events = {
              afterSetExtremes:this.afterSetExtremes
            }
        }else{
          delete this.options.xAxis.events;
        }
      }
    },
    data() {
      return {
        timer: null,

        tipDialogVivible: true,

        //disabled
        queryDisabled: false,
        statisticsDisabled: false,
        dataDisabled: false,
        downloadDisabled: false,

        //Loading
        statisticsLoading: true,
        dataLoading: false,
        chartLoading: false,

        checkBoxAlign: "left",

        downloadSeries: 1,

        switchHidden: false,
        //进度条
        progressHidden: true,
        percentage: 0,
        //pv选择框
        checkAll: false,
        checkedPvList: [],
        pvList: [],
        pvList1: {},
        isIndeterminate: false,

        //pv树形导航栏
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        //路由跳转时是否需要锁定在Dose页面
        lockDose: false,

        //图表属性
        options: {
          //scrollbarEnabled:false,
          chart: {
            height: 550,
            panning: true, //禁用放大
            // pinchType: '', //禁用手势操作
            // zoomType: "",
            // panKey: 'shift',
            zoomType: 'x',
            //panKey: 'shift',
            resetZoomButton: {
              // relativeTo: 'chart',
              animation: false,
              position:{
                x:0,
                y:0
              }
            },
            // spacingBottom:200,
            plotBorderWidth: 1,
            plotBorderColor: 'grey',
            borderRadius:8
          },
          colors: ['#FF0000', '#434348', '#90ed7d', '#f7a35c', '#8085e9',
            '#f15c80', '#e4d354', '#8085e8', '#8d4653', '#91e8e1'],
          noData: {
            style: {
              fontWeight: 'bold',
              fontSize: '15px',
              color: '#303030'
            }
          },
          
          title: {
            text: null
          },
          xAxis: {
            gridLineDashStyle: 'ShortDash',
            gridLineWidth: 1,
            ordinal: false,
            title: {
              text: '',
              style: {
                color: "black",
                fontWeight: 1000
              }
            },
            // type: 'datetime',
            dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%m-%d %H:%M',
              day: '%m-%d %H:%M',
              week: '%m-%d %H:%M',
              month: '%Y-%m-%d %H:%M',
              year: '%Y'
            },
            lineColor: 'black',
            step: 4,
            triggerEvent:false,
            events:{
              afterSetExtremes:this.afterSetExtremes
            },
            minRange:0.1
          },
          yAxis:[],
          lang: {
            downloadCSV: '下载CSV文件',
            noData: "no data"
          },
          tooltip: {
            dateTimeLabelFormats: {
              millisecond: '%m-%d %H:%M:%S.%L',
              second: '%m-%d %H:%M:%S',
              minute: '%m-%d %H:%M',
              hour: '%m-%d %H:%M',
              day: '%Y-%m-%d %H:%M',
              week: '%m-%d %H:%M',
              month: '%Y-%m',
              year: '%Y-%m-%d'
            },
            shared:false
          },
          plotOptions: {
            series: {
              animation: false,
              // turboThreshold: 2000,
              turboThreshold: 0,
              findNearestPointBy:'xy',
            },
            line: {
              dataGrouping: {
                enabled: false
              }
            }
          },
          credits: {
            enabled: false,
          },
          rangeSelector:false,
          navigator: {
            margin: 40,
            //enabled: false
          },
          scrollbar: {
            // enabled:false
            // height:0
          },
          legend: {
            enabled: true,
            verticalAlign: 'bottom',
            // layout: 'vertical',
            align: 'middle',
            layout: 'horizontal',
            maxHeight: 40
          },
          series: [],
          //plotBands: [{
                // Add a plotBand to fill the area above the threshold
                //from: 0.2,
                //to: 0.4, // 设置这个以适应你的数据范围
                //color: 'rgba(0, 0, 0, 0.2)', // 阴影颜色 (红色)
                //zIndex: 0
            //}],
          
          exporting:{
            enabled:true,
            buttons:{
              contextButton: {
                enabled: false
              },
              test:{
                x:0,
                y:2,
                text:'reset',
                titleKey:'reset',
                // symbol:'circle',
                onclick:this.resetChart,
                hoverSymbolFill:null,
                theme:{
                  stroke:'silver',
                  states:{
                    hover:{
                      fill:'#e6e6e6'
                    },
                    select:{
                      stroke:'#039',
                      fill:'#bada55'
                    }
                  }
                }
              }
            }
          }
        },
        switchValue1: false,
        switchValue2: false,
        switchValue3: true,
        switchHidden1: false,
        switchHidden2: false,
        switchHidden3: false,
        pickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value5: [new Date(Date.now() - 3600 * 24 * 1000), new Date(Date.now())],

        dialogTableVisible: false,
        gridData: [{
          BeanCurrent: "asd",
          LifeTime: "asd"
        }],

        statisticsDialogTableVisible: false,
        statisticsData: [],
        pageNumber: 0,
        pageSize: 100,
        currentPage: 1,
        //Aggregate Type的下拉框
        ppOptions:[{
          value:'avg',
          label:'avg'
        },{
          value:'min',
          label:'min'
        },{
          value:'max',
          label:'max'
        }],
        ppOptionsCopy:[{
          value:'First Sample',
          label:'First Sample'
        },{
          value:'Mean',
          label:'Mean'
        },{
          value:'Min',
          label:'Min'
        },{
          value:'Max',
          label:'Max'
        }],
        //选择的Aggregate Type的值
        ppValue:"avg",
        timeMin:null,
        timeMax:null,
        //data source的下拉框
        dataSources:[{
          value:'HBase',
          label:'HBase'
        },{
          value:'AA',
          label:'AA'
        },{
          value:'Oracle',
          label:'Oracle'
        }],
        daSourceValue:'Oracle',
        isDisabled:false,
        currentPagePV:1,
        pageSizePV:15,
        pageSizeAA:1000,
        dianping:["BL01B:WM0:Status","BL03U:WM0:Status","BL04B:WM0:Status","BL07W:WM0:Status","BL08B:WM0:Status","BL09U:WM0:Status","BL10B:WM0:Status","BL11U:WM0:Status","BL12:WM0:Status","BL12B:BS:Status","BL12C:BS:Status","BL13U:WM0:Status"],
        timer:null,
        LiveDate1:null,
        LiveDate2:null,
        startLiveTime:null,
        chart:null,
        yuzhi:[]
      }
    },
    created(){
      let _this = this
    },
    mounted() {
      let a = [];
      let b = [];
      var p, tmp1, tmp2, tmp3;
      let _this = this
      this.cols = this.checkedPvList
      this.$axios
        .get('/hlsTS/pvtree')
        .then(function (response) {
          if (response.status != 200) {
            _this.$notify.error({
              title: '错误',
              message: 'PV列表获取失败',
              position: 'top-right',
              offset: 400,
              duration: 3000
            });
          }
          p = response.data;
          //for (var i in p) {
            //if (!p.hasOwnProperty(p[i])) {
              //tmp1 = {label: i, children: [], pvname: i};
              //if (p[i] != {} && p[i] != null) {
                //for (var j in p[i]) {
                  //if (!p[i].hasOwnProperty(p[i][j])) {
                    //tmp2 = {label: j, children: [], pvname: i + '_' + j};
                    //for (var k = 0; k < p[i][j].length; k++) {
                      //tmp2.children.push({label: p[i][j][k], pvname: i + '_' + j + '_' + p[i][j][k]})
                    //}
                    //tmp1.children.push(tmp2);
                  //}
                //}
              //}
             // a.push(tmp1);
            //}
          //}
          // 递归建树，支持任意层级。
          // node 值为对象 -> 每个 key 递归成子节点；值为空数组 [] -> 叶子节点。
          // pvname 用下划线拼接从根到当前节点的路径。
          var buildTree = function (obj, parentPath) {
            var nodes = [];
            if (obj == null) {
              return nodes;
            }
            for (var key in obj) {
              if (!obj.hasOwnProperty(key)) {
                continue;
              }
              var pvname = parentPath ? parentPath + '_' + key : key;
              var node = {label: key, pvname: pvname, children: []};
              var val = obj[key];
              // 对象（内部节点）才继续递归；空数组 [] 表示叶子，children 保持 []
              if (val != null && typeof val === 'object' && !Array.isArray(val)) {
                node.children = buildTree(val, pvname);
              }
              nodes.push(node);
            }
            return nodes;
          };
          a = buildTree(p, '');
          _this.treeData = a;
        }).catch(function (error) {
        _this.$notify.error({
          title: '错误',
          message: 'PV列表获取失败',
          position: 'top-right',
          offset: 400,
          duration: 3000
        });
      });
      this.treeData = a;

    },
    methods: {
      addBeamCurrSeries: function () {
        if (this.switchValue2 === true) {
          if (this.pvList[0].name === "BeamCurrent") {
            return;
          }
          let p = [];
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          let _this = this;
          if(this.switchValue3 && this.timeMin && this.timeMax){
            date1 = new Date(this.timeMin);
            date2 = new Date(this.timeMax);
          }
          let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
          let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
          
            this.$axios.get('/hlsTS/history/id/617/' + ' ' +'/'+ time1 + '/' + time2)
              .then(function (response) {
                let n = response.data.length;
                _this.options.yAxis.push({
                  gridLineDashStyle: 'ShortDash',
                  gridLineWidth: 0,
                  opposite: true,
                  type: 'linear',
                  title: {
                    text: 'BeamCurrent(mA)',
                    style: {
                      color: "black",
                      fontWeight: 4000
                    }
                  },
                  startOnTick: false,
                  lineColor: 'grey',
                  showFirstLabel: true,
                  showLastLabel: true,
                  min: 0,
                  // max:380,
                  lineWidth: 2
                });
                date1.setMilliseconds(0);
                date2.setMilliseconds(999);
                if(_this.shijianchuo(response.data[0].timestamp.substring(0,13)) <= date1.getTime()){
                  p.push([date1.getTime(), response.data[0].float_val])
                  for (let i = 1; i < n -1; i++) {
                    let str = response.data[i].timestamp;
                    p.push([_this.shijianchuo(str.substring(0,13)), response.data[i].float_val]);
                  }
                  p.push([date2.getTime(), response.data[n - 1].float_val]); 
                }else if(_this.shijianchuo(response.data[0].timestamp.substring(0,13)) > date1.getTime()){
                  p.push([date1.getTime(), null])
                  if (response.data[0].float_val != null && response.data.length > 1) {
                    for (let i = 0; i < n ; i++) {
                      let str = response.data[i].timestamp;
                      p.push([_this.shijianchuo(str.substring(0,13)), response.data[i].float_val]);
                    }
                  }
                  p.push([date2.getTime(), response.data[n - 1].float_val]); 
                }
                // for (var i = 0; i < n; i++) {
                //   let str = response.data[i].timestamp;
                //   p.push([_this.shijianchuo(str.substring(0,13)), response.data[i].float_val]);
                // }
                _this.options.series.push({
                  name: 'RNG:BEAM:CURR',
                  data: p,
                  color: "#0055fa",
                  yAxis: 1,
                  lineWidth: 1.5
                })
              })
          
        } else if (this.switchValue2 === false) {   //关闭开关
          if (this.pvList[0].name === "BeamCurrent") {
            return;
          }
          if (this.options.yAxis[this.options.yAxis.length - 1].title.text === "BeamCurrent(mA)") {
            this.options.yAxis.pop();
          }
          if (this.options.series[this.options.series.length - 1].name === 'RNG:BEAM:CURR') {
            this.options.series.pop();
          }
        }
      },
      changeChartType: function () {
        if (this.switchValue1 === true) {
          // for (let i = 0; i < this.options.yAxis.length; i++){
          //   if(this.options.yAxis[i].title.text === "BeamCurrent(mA)"
          //     && this.options.yAxis[i].opposite === true){
          //     continue;
          //   }
          //   this.options.yAxis[i].type = 'logarithmic';
          //   console.log("change type")
          // }
          this.options.yAxis[0].type = 'logarithmic'
        } else if (this.switchValue1 === false) {
          for (let i = 0; i < this.options.yAxis.length; i++) {
            this.options.yAxis[i].type = 'linear';
          }
        }
      },
      changeSelectType:function(){
        if(this.switchValue3 === true){
          this.options.xAxis.events = {
              afterSetExtremes:this.afterSetExtremes
            }
        }else{
          delete this.options.xAxis.events;
        }
        this.resetChart();

      },
      handleCheckAllChange: function (val) {
        let a = new Array();
        if (val === true) {
          for (let i = 0; i < this.pvList.length; i++) {
            a.push(this.pvList[i].name)
          }
        }
        this.checkedPvList = val ? a : [];
        this.isIndeterminate = false;
      },
      handleCheckedPvListChange: function (val) {
        let checkedCount = val.length;
        this.checkAll = checkedCount === this.pvList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.pvList.length;
        console.log('this.checkedPvList',this.checkedPvList)
      },
      changePvList: function () {
        let _this = this;
        this.$axios.get('/hlsTS/pvlist/BeamCurrent')
          .then(function (response) {
            let n = response.data.length;
            for (let i = 0; i < n; i++) {
              _this.pvList.push(response.data[i]);
            }
          })
      },
      query: function (flag) {
        let _this = this;
        this.clearInter();
        let sum = 0;
        if(flag == 'select'){
          this.switchValue2 = true;
        }else{
          this.switchValue2 = false;
        }
        if (this.checkedPvList === null || this.checkedPvList.length === 0) {
          this.$confirm("请选择需要查询的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        if (this.daSourceValue !== "Oracle" && this.ppValue === "") {
          this.$confirm("请选择需要查询的Aggregate Type", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        this.queryDisabled = false;
        this.chartLoading = false;
        this.switchValue1 = false;
        if (this.options.yAxis.length === 2) {
          this.options.yAxis.pop();
        }
        if (this.options.series.length > 0) {
          if (this.options.series[this.options.yAxis.length - 1].name === "BeamCurrent") {
            this.options.series.pop();
          }
        }
        let q = new Array();
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let checkedPvList = [];
        for (let i = 0; i < this.checkedPvList.length; i++) {
          checkedPvList.push([this.checkedPvList[i]])
        }
        let pvList = "";
        for (let i = 0; i < checkedPvList.length; i++) {
          let flag = false;
          let pv = "";
          for (let j = 0; j < this.pvList.length; j++) {
            if (this.pvList[j].name === checkedPvList[i][0]) {
              flag = true;
              pv = this.pvList[j].pv;
              pvList = pvList + pv + "@";
              checkedPvList[i].push(pv);
              checkedPvList[i].push(this.pvList[j].isState);//是否是状态量
              break;
              
            }
          }
        }
        if( pvList.indexOf("SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai@") != -1){
          pvList.replace(/SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai@/g,"SR-CW-ADAM-20:Slot7:Channel6:ai@LA-CW-ADAM-11:Slot7:Channel6:ai@")
          //checkedPvList.push[['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai'],['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']];
          checkedPvList.push(['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai']);
          checkedPvList.push(['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']);
        }
        if( pvList.indexOf("SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai@") != -1){
          pvList.replace(/SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai@/g,"SR-CW-ADAM-20:Slot7:Channel7:ai@LA-CW-ADAM-11:Slot7:Channel7:ai@")
          //checkedPvList.push[['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai'],['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']];
          checkedPvList.push(['LinacTunnel-T1','SR-CW-ADAM-20:Slot7:Channel7:ai']);
          checkedPvList.push(['LinacTunnel-T2','LA-CW-ADAM-11:Slot7:Channel7:ai']);
        }
        this.options.series = [];
        for (let i = 0; i < checkedPvList.length; i++) {
          if((checkedPvList[i][1] != "SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai") && (checkedPvList[i][1] != "SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai")){
            this.options.series.push({
            name: checkedPvList[i][1],
            data: [],
            yAxis: 0,
            lineWidth: 1.5,
          })
          }
        }
        if (this.pvList[0].name === "BeamCurrent") {
          this.options.series[0].color = "#0055fa";
          if (this.checkedPvList[0] === "BeamCurrent") {
            if (this.checkedPvList.length > 1) {
              this.options.yAxis.push({
                opposite: true,
                type: 'linear',
                title: {
                  text: 'LifeTime(hrs)',
                  style: {
                    color: "black",
                    fontWeight: 1000
                  }
                },
                gridLineWidth: 0,
                lineColor: 'grey',
                showFirstLabel: true,
                showLastLabel: true,
              })
              this.options.series[1].yAxis = 1;
              this.options.series[1].color = "#FF0000";
            }
          } else {
            this.options.yAxis.push({
              opposite: false,
              type: 'linear',
              title: {
                text: 'LifeTime(hrs)',
                style: {
                  color: "black",
                  fontWeight: 1000
                }
              },
              gridLineWidth: 0,
              lineColor: 'grey',
              showFirstLabel: true,
              showLastLabel: true,
            })
            this.options.series[0].yAxis = 1;
            this.options.series[0].color = "#FF0000"
          }
        }
        let emptyPvList = []
        let failedPvList = []
        
          
            //this.$axios.get("/hlsTS/history/nameMap/" + pvList  + '/' + this.ppValue + "/" + time1 + "/" + time2)
            this.$axios.post("/hlsTS/history/nameMap",{
              pvList: pvList,
              type: this.ppValue,
              startTime: time1,
              endTime: time2
            }).then(function (response) {
                _this.options.xAxis.title.text= 'Time';
                if (response.status !== 200) {
                  _this.$confirm("查询失败", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                if (response.data == null || response.data === "" || response.data.length === 0) {
                  _this.$confirm("查询结果为空", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                let data = response.data;
                //console.log("checkedPvList",checkedPvList);//['BL03U:WM0:Status', 'BL03U:WM0:Status', 'true']
                for (let k = 0; k < checkedPvList.length; k++) {
                  let name = checkedPvList[k][1];
                  //let index = _this.dianping.indexOf(name);
                  let isState = checkedPvList[k][2] == "true" ? true : false;
                  if(data[name].is_state){
                    _this.options.series[k].step = 'left';
                    //_this.options.yAxis[0].title.text = "Status(1:on, 2:off, 0:error, 3:error)";
                  }else{
                    _this.options.series[k].step = '';
                    _this.$axios.get('/hlsTS/pvunit/' + _this.pvList[0].pv).then(function (response) {
                      _this.options.yAxis[0].title.text = response.data;
                    })
                  }
                  if (data[name].data == null || data[name].data.length == 0) {
                    emptyPvList.push(name);
                    continue;
                  }
                  let p = [];
                  date1.setMilliseconds(0);
                  date2.setMilliseconds(999);
                  if(shijianchuo(data[name].data[0].timestamp.substring(0,13)) <= date1.getTime()){
                    if(data[name].data[0].float_val!= null){
                      p.push([date1.getTime(), data[name].data[0].float_val])
                      if (data[name].data[0].float_val != null) {
                        for (let i = 1; i < data[name].data.length -1; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].float_val]); 

                        }
                        if(data[name].data.length == 1){
                          let t = date2.getTime() - date1.getTime();
                          p.push([date1.getTime() + t/3 , data[name].data[0].float_val]);
                          p.push([date1.getTime() + t *2/3 , data[name].data[0].float_val]);
                          // p.push([date2.getTime() - t/2, data[name].data[data[name].data.length - 1].float_val]); 
                        }
                      } 
                      //if(shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)) < date2.getTime()){
                       // p.push([shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)), data[name].data[data[name].data.length - 1].float_val]); 
                      //}
                      p.push([date2.getTime(), data[name].data[data[name].data.length - 1].float_val]); 
                    }
                    if((data[name].data[0].float_val == null || data[name].data[0].float_val == 'null')  &&  data[name].data[0].num_val == null){
                      p.push([date1.getTime(), data[name].data[1].float_val])
                      if (data[name].data[1].float_val != null) {
                        for (let i = 2; i < data[name].data.length -1; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].float_val]); 

                        }
                      } 
                      //if(shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)) < date2.getTime()){
                        //p.push([shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)), data[name].data[data[name].data.length - 1].float_val]); 
                      //}
                      p.push([date2.getTime(), data[name].data[data[name].data.length - 1].float_val]); 
                    }
                    if(data[name].data[0].num_val != null){
                      p.push([date1.getTime(), data[name].data[0].num_val])
                      if (data[name].data[0].num_val != null) {
                        for (let i = 1; i < data[name].data.length -1; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].num_val]); 

                        }
                        if(data[name].data.length == 1){
                          let t = date2.getTime() - date1.getTime();
                          p.push([date1.getTime() + t/3 , data[name].data[0].num_val]);
                          p.push([date1.getTime() + t *2/3 , data[name].data[0].num_val]);
                          // p.push([date2.getTime() - t/2, data[name].data[data[name].data.length - 1].float_val]); 
                        }
                      } 
                      //if(shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)) < date2.getTime()){
                        //p.push([shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)), data[name].data[data[name].data.length - 1].num_val]); 
                      //}
                      p.push([date2.getTime(), data[name].data[data[name].data.length - 1].num_val]); 
                    }
                   
                  }else if(shijianchuo(data[name].data[0].timestamp.substring(0,13)) > date1.getTime()){
                    if(data[name].data[0].float_val != null){
                      p.push([date1.getTime(), null])
                      if (data[name].data[0].float_val != null && data[name].data.length > 1) {
                        for (let i = 0; i < data[name].data.length; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].float_val]); 

                        }
                      } 
                      //if(shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)) < date2.getTime()){
                       // p.push([shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)), data[name].data[data[name].data.length - 1].float_val]); 
                      //}
                      p.push([date2.getTime(),data[name].data[data[name].data.length-1].float_val]); 
                    }
                    if(data[name].data[0].num_val != null){
                      p.push([date1.getTime(), null])
                      if (data[name].data[0].num_val != null && data[name].data.length > 1) {
                        for (let i = 0; i < data[name].data.length; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].num_val]); 

                        }
                      } 
                      //if(shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)) < date2.getTime()){
                       // p.push([shijianchuo(data[name].data[data[name].data.length - 1].timestamp.substring(0,13)), data[name].data[data[name].data.length - 1].num_val]); 
                      //}
                      p.push([date2.getTime(),data[name].data[data[name].data.length-1].num_val]); 
                    }
                   

                  }
                  console.log(_this.options.yAxis)
                  _this.options.xAxis.title.text= data[name].data[0].t;
                  // _this.options.series[k].step = 'left';
                  _this.options.series[k].data = p;
                  // _this.options.series[k].data = pp;
                  sum+=_this.options.series[k].data.length
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
            })
          
            
        
        
        function shijianchuo(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
        }
        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      nodeClicked: function (arg1, arg2, arg3) {
        console.log
        let a = arg1;
        let flag = true;
        for (var i in arg1) {
          if (i == "children" && arg1[i].length != 0) {
            flag = false;
          }
        }
        let name;
        let _this = this;
        if (flag == true) {
          clearInterval(this.timer);
          this.timeMin = null;
          this.timeMax = null;
          this.ppValue = "avg";
          this.value5 = []
          this.value5.push(new Date(Date.now() - 3600 * 24 * 1000))
          this.value5.push(new Date(Date.now()))
          this.progressHidden = true
          this.switchHidden = false;
          this.checkBoxAlign = "center"
          this.options.yAxis = []
          this.isIndeterminate = false;
          this.switchValue1 = false;
          this.switchValue2 = false;
          this.checkAll = false;
          this.queryDisabled = false
          this.statisticsLoading = true
          this.dataLoading = true
          this.downloadDisabled = false
          this.checkedPvList = [];    //清空多选框，清空pvList列表
          this.statisticsData = [];
          this.options.series = [];
          this.gridData = [];
          for (let i in arg1) {
            if (i == "pvname") {
              name = arg1[i]
            }
          }
          this.options.title.text = name;
          if(name === "BeamCurrent"){
            console.log("name1"+name)
              this.switchHidden = false;
              this.switchHidden2 = true;
              this.switchValue3 = true;
          }else{
            console.log("name2"+name)
              this.switchHidden2 = false;
              this.switchValue3 = true;
          }
          this.$axios.get('/hlsTS/pvlist/' + name)
            .then(function (response) {
              if (response.status != 200) {
                _this.$notify.error({
                  title: '错误',
                  message: 'PV列表获取失败',
                  position: 'top-right',
                  offset: 400,
                  duration: 3000
                });
              }
              _this.pvList.length = 0;
              if (response.data.length > 5) {
                _this.checkBoxAlign = "left"
              }
              _this.yuzhi = [];
              for (let i = 0; i < response.data.length; i++) {
                _this.pvList1[response.data[i].name] = response.data[i].pv
                _this.pvList.push(response.data[i]);
                let obj = {
                  yuzhi1:"",
                  yuzhi2:""
                }
              _this.yuzhi.push(obj);
              }
              if (_this.pvList[0].name === "BeamCurrent") {
                _this.options.yAxis.push({
                  showFirstLabel: true,
                  showLastLabel: true,
                  gridLineWidth: 0,
                  lineColor: 'grey',
                  title: {
                    text: "Current(mA)",
                    style: {
                      color: "black",
                      fontWeight: 1000
                    }
                  },
                  opposite: false, lineWidth: 2
                })
                _this.options.yAxis.push({
                  showFirstLabel: true,
                  showLastLabel: true,
                  gridLineDashStyle: 'ShortDash',
                  gridLineWidth: 0,
                  lineColor: 'grey',
                  title: {text: "LifeTime(hrs)"},
                  opposite: true, lineWidth: 2
                })
              } else {
                _this.$axios.get('/hlsTS/pvunit/' + _this.pvList[0].pv)
                  .then(function (response) {
                    _this.options.yAxis.push({
                      showFirstLabel: true,
                      showLastLabel: true,
                      gridLineDashStyle: 'ShortDash',
                      gridLineWidth: 0,
                      type: 'linear',
                      lineColor: 'grey',
                      title: {
                        text: response.data,
                        style: {
                          color: "black",
                          fontWeight: 1000
                        }
                      },
                      opposite: false, 
                      lineWidth: 2,
                     
                    })
                  })
              }
            })

        }
      },
      showStatistics: function () {
        this.clearInter();
        if (this.checkedPvList === null || this.checkedPvList.length === 0) {
          this.$confirm("请选择需要查询的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        this.statisticsDialogTableVisible = true;
        this.statisticsLoading = false
        this.statisticsData = []
        let p = new Array();
        let q = new Array();
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let _this = this;
        let checkedPvList = this.checkedPvList;
        let count = this.checkedPvList.length;
        let failedPvList = []
        let emptyPvList = []
        for (let i = 0; i < checkedPvList.length; i++) {
          let pv = this.pvList1[this.checkedPvList[i]];
          let name = this.checkedPvList[i];
          let p = new Array();
          _this.statisticsData.push({
            Pv_Name: name,
            Mean: null,
            Deviation: null,
            RMS: null,
            Max: null,
            Min: null
          })
           
              
             this.$axios.get("/hlsTS/history/statistics/" + pv + "/" + time1 + "/" + time2)
              .then(function (response) {
                if (response.status != 200) {
                  failedPvList.push(pv)
                  if (--count === 0) {
                    if (failedPvList.length !== 0) {
                      let str = "  ";
                      for (let j = 0; j < failedPvList.length; j++) {
                        str += failedPvList[j] + "  ";
                      }
                      _this.$notify.error({
                        title: 'error',
                        message: '查询' + failedPvList + "失败",
                        position: 'top-right',
                        offset: 400,
                        duration: 3000
                      })
                    }
                    if (emptyPvList.length !== 0) {
                      for (let j = 0; j < emptyPvList.length; j++) {
                        str += emptyPvList[j] + "  ";
                      }
                      _this.$notify.error({
                        title: 'error',
                        message: emptyPvList + "查询结果为空",
                        position: 'top-right',
                        offset: 400,
                        duration: 3000
                      })
                    }
                    _this.statisticsLoading = true
                  }
                  return;
                }
                if (response.data == null || response.data === "") {
                  emptyPvList.push(pv)
                  if (--count === 0) {
                    alertInfo(failedPvList, emptyPvList)
                    _this.statisticsLoading = true
                  }
                  return;
                }
                for (let o in _this.statisticsData[i]) {
                  if (o !== 'Pv_Name') {
                    console.log(o)
                    if (Math.abs(response.data[o]) < 0.1) {
                      if (o === 'Deviation') {
                      }
                      _this.statisticsData[i][o] = response.data[o] !== null ? response.data[o].toPrecision(6) : null;
                      
                    } else {
                      _this.statisticsData[i][o] = response.data[o] !== null ? response.data[o].toFixed(6) : null;
                    }
                  }
                }
                // _this.statisticsData[i].Mean = response.data.Mean
                // _this.statisticsData[i].Deviation = response.data.Deviation
                // _this.statisticsData[i].RMS = response.data.RMS
                // _this.statisticsData[i].Max = response.data.Max
                // _this.statisticsData[i].Min = response.data.Min
                if (--count === 0) {
                  alertInfo(failedPvList, emptyPvList)
                  _this.statisticsLoading = true;
                }
              })
              .catch(function (error) {
                  failedPvList.push(pv)
                  if (--count === 0) {
                    alertInfo(failedPvList, emptyPvList)
                    _this.statisticsLoading = true;
                  }
                }
              );
           
        }

        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: '查询' + str + "失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      downloadData: function () {
        //let _this = this;
        //this.clearInter();
        //if (this.checkedPvList === null || this.checkedPvList.length === 0) {
         // this.$confirm("请选择需要下载的PV", "提示", {
           // showCancelButton: false,
           // showConfirmButton: false,
         // })
         // return;
       // }
        //默认选择传统下载方式
        this.downloadDataTraditional();

        // 让用户选择下载方式
        //this.$confirm('请选择下载方式', '下载方式选择', {
          //distinguishCancelAndClose: true,
         //confirmButtonText: '流式下载（推荐）',
          //cancelButtonText: '传统下载',
         // type: 'info',
         // center: true
        //}).then(() => {
          // 用户选择流式下载
         // _this.downloadDataStream();
        //}).catch((action) => {
          //if (action === 'cancel') {
             //用户选择传统下载
           //_this.downloadDataTraditional();
          //}
        //});
      },

      // 新增：流式下载方法
      downloadDataStream: function () {
        this.clearInter();
        let _this = this;
        let checkedPvList = this.checkedPvList;

        this.downloadSeries = 1;
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let name = new Date(Date.now()).format("yyyy_MM_dd_hh_mm_ss");
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");

        // 构建PV列表
        let pvList = "";
        for (let i = 0; i < checkedPvList.length; i++) {
          let flag = false;
          let pv = "";
          let pvName = "";
          for (let j = 0; j < this.pvList.length; j++) {
            if (this.pvList[j].name === checkedPvList[i]) {
              flag = true;
              pv = this.pvList[j].pv;
              pvList = pvList + pv + "@";
              pvName = this.pvList[j].name;
              break;
            }
          }
        }

        // 禁用下载按钮
        this.downloadDisabled = true;

        // 先获取文件大小估计
        //this.$confirm("正在计算文件大小和下载时间", "提示", {
         // showCancelButton: false,
         // showConfirmButton: false,
         // closeOnClickModal: false,
         // closeOnPressEscape: false,
        //  closeOnHashChange: false
       // });
        // 用户确认后，开始流式下载
        _this.startStreamDownload(time1, time2, name, pvList);
        //this.$axios.get('/hlsTS/download/' + pvList + "/" + time1 + "/" + time2)
         // .then(function (response) {
           // _this.$msgbox.close();
           // _this.$confirm(
           //   "Estimated file size: " + (response.data / 30000).toFixed(3) + "M, " +
           //   "download time:" + (response.data / 40000).toFixed(2) + "s， continue?",
           //   "Tips",
            //  {
             //   confirmButtonText: 'confirm',
            //    cancelButtonText: 'cancel',
             //   type: 'warning'
             // }
            //).then(() => {
              // 用户确认后，开始流式下载
             // _this.startStreamDownload(time1, time2, name, pvList);
            //}).catch(() => {
            //  _this.downloadDisabled = false;
            //});
          //}).catch((error) => {
           // _this.$msgbox.close();
           // _this.downloadDisabled = false;
           // _this.$notify.error({
             // title: 'Error',
             // message: '获取文件大小失败: ' + error.message,
             // duration: 3000
           // });
          //});
      },

      // 新增：执行流式下载
      startStreamDownload: function(time1, time2, name, pvList) {
        let _this = this;

        // DBPM 特殊数据处理：判断是否为 DBPM 特定 PV，使用不同的 API 端点
        let streamUrl = '/hlsTS/download/stream/';
        if (pvList === "SR-BD-DBPM01:bpm1:fa.X@" || pvList === "SR-BD-DBPM03:bpm2:fa.X@") {
          streamUrl = '/hlsTS/download/stream/DBPM/';
        }

        // 创建右上角进度提示框
        let progressBox = document.createElement('div');
        progressBox.id = 'download-progress-' + Date.now();
        progressBox.style.cssText = `
          position: fixed;
          top: 20px;
          right: 10px;
          background: white;
          padding: 16px 20px;
          border-radius: 4px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          z-index: 9999;
          min-width: 300px;
          max-width: 400px;
          border-left: 4px solid #409EFF;
        `;

        let progressContent = document.createElement('div');
        progressContent.innerHTML = `
          <div id="${progressBox.id}-header" style="display: flex; align-items: center; margin-bottom: 8px;">
            <i id="${progressBox.id}-icon" class="el-icon-loading" style="font-size: 18px; color: #409EFF; margin-right: 8px;"></i>
            <strong id="${progressBox.id}-title" style="font-size: 14px; color: #303133;">Downloading...</strong>
          </div>
          <div id="${progressBox.id}-text" style="font-size: 13px; color: #606266; margin-bottom: 8px;">
            Preparing download...
          </div>
          <div id="${progressBox.id}-bar" style="width: 100%; height: 6px; background: #EBEEF5; border-radius: 3px; overflow: hidden; display: none;">
            <div id="${progressBox.id}-bar-inner" style="height: 100%; width: 0%; background: linear-gradient(to right, #409EFF, #66B1FF); transition: width 0.3s ease;"></div>
          </div>
        `;
        progressBox.appendChild(progressContent);
        document.body.appendChild(progressBox);

        let progressTitle = document.getElementById(progressBox.id + '-title');
        let progressIcon = document.getElementById(progressBox.id + '-icon');
        let progressText = document.getElementById(progressBox.id + '-text');
        let progressBar = document.getElementById(progressBox.id + '-bar');
        let progressBarInner = document.getElementById(progressBox.id + '-bar-inner');

        // 使用axios下载流
        this.$axios({
          method: 'get',
          url: streamUrl + time1 + "/" + time2 + "/" + name + "/" + pvList,  // 使用参数化 URL，支持 DBPM
          responseType: 'blob',  // 关键：设置响应类型为blob
          timeout: 1800000,  // 30分钟超时（与后端配置匹配）
          onDownloadProgress: function (progressEvent) {
            // 更新下载进度
            if (progressEvent.lengthComputable && progressEvent.total > 0) {
              // 如果服务器提供了Content-Length
              let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              let downloadedMB = (progressEvent.loaded / 1024 / 1024).toFixed(2);
              let totalMB = (progressEvent.total / 1024 / 1024).toFixed(2);
              if (progressText) {
                progressText.innerHTML = `
                  <div style="margin-bottom: 4px; font-weight: 500;">${percentCompleted}% completed</div>
                  <div style="color: #909399; font-size: 12px;">${downloadedMB} MB / ${totalMB} MB</div>
                `;
              }
              // 显示并更新进度条
              if (progressBar) {
                progressBar.style.display = 'block';
              }
              if (progressBarInner) {
                progressBarInner.style.width = percentCompleted + '%';
              }
            } else {
              // 流式下载时Content-Length可能为0，只显示已下载大小
              let downloadedMB = (progressEvent.loaded / 1024 / 1024).toFixed(2);
              if (progressText) {
                progressText.innerHTML = `
                  <div>Downloaded: ${downloadedMB} MB</div>
                `;
              }
              // 隐藏进度条（无法计算百分比）
              if (progressBar) {
                progressBar.style.display = 'none';
              }
            }
          }
        }).then(function (response) {
          // 下载完成，更新标题和图标
          if (progressTitle) {
            progressTitle.textContent = 'Download completed';
            progressTitle.style.color = '#67C23A';
          }
          if (progressIcon) {
            progressIcon.className = 'el-icon-success';
            progressIcon.style.color = '#67C23A';
          }
          // 更新进度为100%
          if (progressText) {
            let finalSize = (response.data.size / 1024 / 1024).toFixed(2);
            progressText.innerHTML = `
              <div style="margin-bottom: 4px; font-weight: 500; color: #67C23A;">100% completed</div>
              <div style="color: #909399; font-size: 12px;">${finalSize} MB / ${finalSize} MB</div>
            `;
          }
          if (progressBarInner) {
            progressBarInner.style.width = '100%';
            progressBarInner.style.background = 'linear-gradient(to right, #67C23A, #85CE61)';
          }

          // 创建Blob对象
          const blob = new Blob([response.data], { type: 'application/octet-stream' });

          // 创建下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', name + '.txt');

          // 触发下载
          document.body.appendChild(link);
          link.click();

          // 清理
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          _this.$notify.success({
            title: 'Success',
            message: 'Download completed!',
            duration: 2000,
          });
        }).catch(function (error) {
          console.error('Stream download error:', error);

          _this.$notify.error({
            title: 'Error',
            message: 'Download failed: ' + (error.message || 'Unknown error'),
            duration: 3000,
          });
        }).finally(function () {
          // 延迟移除进度提示框，让用户看到完成状态
          setTimeout(function() {
            if (progressBox && progressBox.parentNode) {
              // 添加淡出动画
              progressBox.style.transition = 'opacity 0.3s';
              progressBox.style.opacity = '0';
              setTimeout(function() {
                if (progressBox.parentNode) {
                  progressBox.parentNode.removeChild(progressBox);
                }
              }, 300);
            }
          }, 800);  // 停留800ms让用户看到100%状态

          _this.downloadDisabled = false;
        });
      },

      // 保留原有方法，重命名为 downloadDataTraditional
      downloadDataTraditional: function () {
        this.clearInter();
        if (this.checkedPvList === null || this.checkedPvList.length === 0) {
          this.$confirm("请选择需要下载的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        this.downloadSeries = 1;
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let name = new Date(Date.now()).format("yyyy_MM_dd_hh_mm_ss");
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let checkedPvList = this.checkedPvList;
        let pvList = "";
        let _this = this;
        for (let i = 0; i < checkedPvList.length; i++) {
          let flag = false;
          let pv = "";
          let name = "";
          for (let j = 0; j < this.pvList.length; j++) {
            if (this.pvList[j].name === checkedPvList[i]) {
              flag = true;
              pv = this.pvList[j].pv;
              pvList = pvList + pv + "@";
              name = this.pvList[j].name;
              break;
            }
          }
        }
        this.downloadDisabled = true;

        // 创建右上角进度提示框
        let progressBox = document.createElement('div');
        progressBox.id = 'download-progress-traditional-' + Date.now();
        progressBox.style.cssText = `
          position: fixed;
          top: 20px;
          right: 10px;
          background: white;
          padding: 16px 20px;
          border-radius: 4px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          z-index: 9999;
          min-width: 300px;
          max-width: 400px;
          border-left: 4px solid #409EFF;
        `;

        let progressContent = document.createElement('div');
        progressContent.innerHTML = `
          <div id="${progressBox.id}-header" style="display: flex; align-items: center; margin-bottom: 8px;">
            <i id="${progressBox.id}-icon" class="el-icon-loading" style="font-size: 18px; color: #409EFF; margin-right: 8px;"></i>
            <span id="${progressBox.id}-title" style="font-weight: 500; color: #303133;">正在准备下载...</span>
          </div>
          <div id="${progressBox.id}-text" style="color: #606266; font-size: 14px; margin-bottom: 8px;">
            <div>正在计算文件大小...</div>
          </div>
          <div id="${progressBox.id}-bar" style="margin-top: 8px;">
            <div style="background: #EBEEF5; height: 6px; border-radius: 3px; overflow: hidden;">
              <div id="${progressBox.id}-progress" style="background: linear-gradient(to right, #409EFF, #66B1FF); height: 100%; width: 0%; transition: width 0.3s;"></div>
            </div>
          </div>
        `;

        progressBox.appendChild(progressContent);
        document.body.appendChild(progressBox);

        // 保存DOM元素引用
        let progressTitle = document.getElementById(progressBox.id + '-title');
        let progressText = document.getElementById(progressBox.id + '-text');
        let progressBar = document.getElementById(progressBox.id + '-progress');
        let progressIcon = document.getElementById(progressBox.id + '-icon');

        // this.$axios.get(_this.urlFragment + '/download/' + pvList + "/" + time1 + "/" + time2)
        //this.$axios.get( '/hlsTS/download/' + pvList + "/" + time1 + "/" + time2)
        this.$axios.post( '/hlsTS/download/count',{
          pvList: pvList,
          startTime: time1,
          endTime: time2
        }).then(function (response) {
           // _this.$msgbox.close()

            if (!(pvList == null || pvList.length == 0)) {
              _this.downloadDisabled = true;
              _this.progressHidden = false;

              // 获取总文件大小（字节）
              let totalFileSize = response.data || 0;
              let totalSizeMB = (totalFileSize / 1024 / 1024).toFixed(2);

              // 更新进度框状态为下载中
              if (progressTitle) {
                progressTitle.textContent = '正在下载中';
              }
              if (progressText) {
                progressText.innerHTML = `
                  <div style="margin-bottom: 4px;">请勿离开当前页面</div>
                  <div style="color: #909399; font-size: 12px;">已下载：0 MB / ${totalSizeMB} MB</div>
                `;
              }

              // 开始轮询下载进度
              _this.timer = setInterval(function() {
                _this.$axios.get( '/hlsTS/download/status/' + name)
                  .then(function (response) {
                    _this.downloadSeries = response.data[0]
                    _this.percentage = response.data[1]

                    // 计算已下载大小
                    let downloadedSize = (totalFileSize * _this.percentage / 100 / 1024 / 1024).toFixed(2);

                    // 更新进度条
                    if (progressBar) {
                      progressBar.style.width = _this.percentage + '%';
                    }
                    if (progressText) {
                      progressText.innerHTML = `
                        <div style="margin-bottom: 4px; font-weight: 500;">${_this.percentage}% 已完成</div>
                        <div style="color: #909399; font-size: 12px;">已下载：${downloadedSize} MB / ${totalSizeMB} MB</div>
                      `;
                    }
                  })
              }, 1000);

              // _this.$axios.get(_this.urlFragment + '/download/' + time1 + "/" + time2 + "/" + name + "/" + pvList)
              //_this.$axios.get('/hlsTS/download/' + time1 + "/" + time2 + "/" + name + "/" + pvList)
              _this.$axios.post('/hlsTS/download/pvlist',{
                startTime: time1,
                endTime: time2,
                name: name,
                pvList: pvList
              }).then(function (response) {
                  // 下载完成
                  if (progressTitle) {
                    progressTitle.textContent = '下载完成';
                    progressTitle.style.color = '#67C23A';
                  }
                  if (progressIcon) {
                    progressIcon.className = 'el-icon-success';
                    progressIcon.style.color = '#67C23A';
                  }
                  if (progressBar) {
                    progressBar.style.width = '100%';
                    progressBar.style.background = '#67C23A';
                  }
                  if (progressText) {
                    progressText.innerHTML = `
                      <div style="margin-bottom: 4px; font-weight: 500; color: #67C23A;">100% 已完成</div>
                      <div style="color: #909399; font-size: 12px;">已下载：${totalSizeMB} MB / ${totalSizeMB} MB</div>
                    `;
                  }

                  // 3秒后自动关闭进度框
                  setTimeout(() => {
                    if (progressBox && progressBox.parentNode) {
                      progressBox.parentNode.removeChild(progressBox);
                    }
                  }, 3000);

                  let str = window.location.href;
                  window.open('http://' + str.split("/")[2] + '/hlsTS/download/media/' + response.data)
                  //window.open('http://' + '192.168.125.194:8080' + '/hlsTS/download/media/'+response.data)
                  _this.progressHidden = true;
                  _this.downloadDisabled = false
                  clearInterval(_this.timer);
                  _this.percentage = 0;
                })
                .catch(function(error) {
                  // 下载失败
                  if (progressTitle) {
                    progressTitle.textContent = '下载失败';
                    progressTitle.style.color = '#F56C6C';
                  }
                  if (progressIcon) {
                    progressIcon.className = 'el-icon-error';
                    progressIcon.style.color = '#F56C6C';
                  }
                  if (progressText) {
                    progressText.innerHTML = '<div style="color: #F56C6C;">下载失败，请重试</div>';
                  }

                  // 5秒后自动关闭进度框
                  setTimeout(() => {
                    if (progressBox && progressBox.parentNode) {
                      progressBox.parentNode.removeChild(progressBox);
                    }
                  }, 5000);

                  _this.progressHidden = true;
                  _this.downloadDisabled = false;
                  clearInterval(_this.timer);
                  _this.percentage = 0;
                });
            }
          })
          .catch(function(error) {
            // 获取文件大小失败
            if (progressTitle) {
              progressTitle.textContent = '准备失败';
              progressTitle.style.color = '#F56C6C';
            }
            if (progressIcon) {
              progressIcon.className = 'el-icon-error';
              progressIcon.style.color = '#F56C6C';
            }
            if (progressText) {
              progressText.innerHTML = '<div style="color: #F56C6C;">准备下载失败，请重试</div>';
            }

            // 5秒后自动关闭进度框
            setTimeout(() => {
              if (progressBox && progressBox.parentNode) {
                progressBox.parentNode.removeChild(progressBox);
              }
            }, 5000);

            _this.downloadDisabled = false;
          })
        
      },
      showData: function () {
        this.clearInter();
        if (this.checkedPvList === null || this.checkedPvList.length === 0) {
          this.$confirm("请选择需要查询的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        this.currentPage = 1;
        this.gridData = [];
        this.dataLoading = false
        this.dialogTableVisible = true;
        this.pageNumber = 1;
        let p1 = new Array();
        let q = new Array();
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let checkedPvList = this.checkedPvList;
        let pvList = "";
        let tmpData = new Array();
        let count = this.checkedPvList.length;
        for (let i = 0; i < this.pageSize; i++) {
          tmpData.push({})
        }
        let _this = this;
        for (let i = 0; i < checkedPvList.length; i++) {
          for (let j = 0; j < this.pageSize; j++) {
            tmpData[j][checkedPvList[i]] = "";
          }
          let pv = this.pvList1[this.checkedPvList[i]];
          let name = this.checkedPvList[i];
          pvList = pvList + pv + "@";
        }
        console.log('tmpData'+tmpData)
        this.gridData = tmpData
        
          //this.$axios.get("/hlsTS/history/page/count/" + pvList + "/" + time1 + "/" + time2)
          this.$axios.post("/hlsTS/history/page/count",{
            nameList: pvList,
            startTime: time1,
            endTime: time2
          }).then(function (response) {
             
              _this.pageNumber = Math.ceil(response.data % _this.pageSize ? response.data / _this.pageSize : response.data / _this.pageSize + 1);

            })
          for (let i = 0; i < checkedPvList.length; i++) {
            let pv = this.pvList1[this.checkedPvList[i]];
            let name = this.checkedPvList[i];
            let p = new Array();
            let val = 1
            this.$axios.get("/hlsTS/history/page/" + val + "/" + this.pageSize + "/" + pv + "/" + time1 + "/" + time2)
              .then(function (response) {
                if (response.status != 200) {
                  // _this.$notify.error({
                  //   title: '错误',
                  //   message: 'PV ' + pv + " 查询失败",
                  //   position: 'top-right',
                  //   offset:400
                  // });
                  if (--count === 0) {
                    _this.dataLoading = true
                  }
                  return;
                } else if (response.data == null || response.data === "" || response.data.length === 0) {
                  // _this.$notify.error({
                  //   title: '错误',
                  //   message: 'PV ' + name + " 查询结果为空",
                  //   position: 'top-right',
                  //   offset:400
                  // });
                  if (--count === 0) {
                    _this.dataLoading = true
                  }
                  return;
                }
                if (response.data[0].float_val != null) {
                  for (let j = 0; j < response.data.length; j++) {
                    let timeStamp = _this.shijianchuo(response.data[j].timestamp.substring(0,13));
                    let time = new Date(timeStamp).format("yyyy-MM-dd hh:mm:ss.S");
                    //排除为0的情况
                    if (Math.abs(response.data[j].float_val) < 0.1 && Math.abs(response.data[j].float_val) > 1e-10) {
                      _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                        response.data[j].float_val.toPrecision(6);
                    }  else if(typeof response.data[j].float_val === 'number' ){
                      _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                        response.data[j].float_val;
                    }else {
                      _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                        response.data[j].float_val;
                    }
                  }
                
                }
                if(response.data[0].num_val != null) {
                  for (let j = 0; j < response.data.length; j++) {
                    let timeStamp = _this.shijianchuo(response.data[j].timestamp.substring(0,13));
                    let time = new Date(timeStamp).format("yyyy-MM-dd hh:mm:ss.S");
                    _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" + response.data[j].num_val;
                  }
                 
                }
                if (--count === 0) {
                  _this.dataLoading = true;
                }
            })
          }
        
      },
      shijianchuo:function(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
      },
      pageChange: function (val) {
        this.dataLoading = true;
        this.currentPage = val;
        this.gridData = [];
        let p = new Array();
        let q = new Array();
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let _this = this;
        let pvList = "";
        let tmpData = new Array();
        let count = this.checkedPvList.length;
        for (let i = 0; i < this.pageSize; i++) {
          tmpData.push({})
        }
        let checkedPvList = this.checkedPvList;
        //this.options.series = [];
        for (let i = 0; i < checkedPvList.length; i++) {
          for (let j = 0; j < this.pageSize; j++) {
            tmpData[j][checkedPvList[i]] = "";
          }
        }
        this.gridData = tmpData;
        for (let i = 0; i < checkedPvList.length; i++) {
          let flag = false;
          let pv = this.pvList1[this.checkedPvList[i]];
          let name = this.checkedPvList[i];
          pvList = pvList + pv + "@";
          let p = new Array();
          
            this.$axios.get("/hlsTS/history/page/" + val + "/" + this.pageSize + "/" + pv + "/" + time1 + "/" + time2)
              .then(function (response) {
                if (response.data[0].float_val !== null) {
                  for (let j = 0; j < response.data.length; j++) {
                    let timeStamp = _this.shijianchuo(response.data[j].timestamp.substring(0,13));
                    let time = new Date(timeStamp).format("yyyy-MM-dd hh:mm:ss.S");
                    if (Math.abs(response.data[j].float_val) < 0.1) {
                      _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                        response.data[j].float_val.toPrecision(6);
                    } else {
                      _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                        response.data[j].float_val.toFixed(6);
                    }
                  }
                } else {
                  for (let j = 0; j < response.data.length; j++) {
                    let timeStamp = _this.shijianchuo(response.data[j].timestamp.substring(0,13));
                    let time = new Date(timeStamp).format("yyyy-MM-dd hh:mm:ss.S");
                    _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                      response.data[j].num_val.toPrecision(6);
                  }
                }
                if (--count === 0) {
                  _this.dataLoading = true;
                }
              })
        }
      },
      //图表框选事件
      afterSetExtremes:function(e){
        this.timeMin = e.min;
        this.timeMax = e.max;
        if(this.switchValue2){
          this.query('select');
        }else{
          this.query();
        }
        if(this.switchValue3){
            this.addBeamCurrSeries();
        }
        
      },
      //dataSource下拉框值变化时
      changeDataSource:function(value){
        if(value == "HBase"){
          this.ppValue = "Max"
          this.isDisabled = false
          this.ppOptions = this.ppOptionsCopy
        }else if(value == "AA"){
          this.ppValue = "Max"
          this.isDisabled = false
          this.ppOptions = this.ppOptionsCopy.slice(1)
        }else{
          this.ppValue = ""
          this.isDisabled = true
        }
      },
      currentChangepV:function(val){
        console.log("val",val)
        this.currentPagePV = val;
      },
      resetChart:function(){
        this.timeMin = null;
        this.timeMax = null;
        //this.ppValue = "avg";
        this.query();
      },
      getLocaltime:function(){
        let _this = this;
        let date1 = new Date(new Date().getTime() - 5*60*1000);
        let date2 = new Date();
        let livedate1 = null;
        let livedate2 = null;
        livedate1= new Date(date1.getTime());
        livedate2 = new Date(date2.getTime());
        _this.queryLive123(livedate1,livedate2);
        // if(date2.getTime() - _this.startLiveTime.getTime() > 3*60*1000){
        //   clearInterval(this.timer);
        // }
      },
      liveData:function(){
        let _this = this;
        let gap = 5*60/1;
        let livedate2;
        let livedate1;
        // let date1 = new Date(this.value5[0]);
        
        // if(this.switchValue3 && this.timeMin && this.timeMax){
        //   date1 = new Date(this.timeMin);
        //   date2 = new Date(this.timeMax);
        // }
          let date1 = new Date(new Date().getTime() - 5*60*1000);
          let date2 = new Date();
          _this.startLiveTime = date2;
          livedate1 = new Date(date1.getTime());
          livedate2 = new Date(date2.getTime());
          _this.queryLive(livedate1,livedate2);
          _this.timer = setInterval(()=>{
           _this.getLocaltime()
        },3000);
        
      },
      queryLive: function (date1,date2) {
        let sum = 0;
        // if(flag == 'select'){
        //   this.switchValue2 = true;
        // }else{
        //   this.switchValue2 = false;
        // }
        if (this.checkedPvList === null || this.checkedPvList.length === 0) {
          this.$confirm("请选择需要查询的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        if (this.daSourceValue !== "Oracle" && this.ppValue === "") {
          this.$confirm("请选择需要查询的Aggregate Type", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        this.queryDisabled = false;
        this.chartLoading = false;
        this.switchValue1 = false;
        if (this.options.yAxis.length === 2) {
          this.options.yAxis.pop();
        }
        if (this.options.series.length > 0) {
          if (this.options.series[this.options.yAxis.length - 1].name === "BeamCurrent") {
            this.options.series.pop();
          }
        }
        let q = new Array();
        // let date1 = new Date(this.value5[0]);
        // let date2 = new Date(this.value5[1]);
        // let date1 = livedate1;
        // let date2 = livedate2;
        // if(this.switchValue3 && this.timeMin && this.timeMax){
        //   date1 = new Date(this.timeMin);
        //   date2 = new Date(this.timeMax);
        // }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let _this = this;
        let checkedPvList = [];
        for (let i = 0; i < this.checkedPvList.length; i++) {
          checkedPvList.push([this.checkedPvList[i]])
        }
        let pvList = ""
        for (let i = 0; i < checkedPvList.length; i++) {
          let flag = false;
          let pv = "";
          for (let j = 0; j < this.pvList.length; j++) {
            if (this.pvList[j].name === checkedPvList[i][0]) {
              flag = true;
              pv = this.pvList[j].pv;
              pvList = pvList + pv + "@";
              checkedPvList[i].push(pv)
              break;
              
            }
          }
        }
        if( pvList.indexOf("SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai@") != -1){
          pvList.replace(/SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai@/g,"SR-CW-ADAM-20:Slot7:Channel6:ai@LA-CW-ADAM-11:Slot7:Channel6:ai@")
          //checkedPvList.push[['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai'],['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']];
          checkedPvList.push(['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai']);
          checkedPvList.push(['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']);
        }
        if( pvList.indexOf("SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai@") != -1){
          pvList.replace(/SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai@/g,"SR-CW-ADAM-20:Slot7:Channel7:ai@LA-CW-ADAM-11:Slot7:Channel7:ai@")
          //checkedPvList.push[['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai'],['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']];
          checkedPvList.push(['LinacTunnel-T1','SR-CW-ADAM-20:Slot7:Channel7:ai']);
          checkedPvList.push(['LinacTunnel-T2','LA-CW-ADAM-11:Slot7:Channel7:ai']);
        }
        this.options.series = [];
        for (let i = 0; i < checkedPvList.length; i++) {
          if((checkedPvList[i][1] != "SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai") && (checkedPvList[i][1] != "SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai")){
            this.options.series.push({
            name: checkedPvList[i][1],
            data: [],
            yAxis: 0,
            lineWidth: 1.5
          })
          }
        }
        if (this.pvList[0].name === "BeamCurrent") {
          this.options.series[0].color = "#0055fa";
          if (this.checkedPvList[0] === "BeamCurrent") {
            if (this.checkedPvList.length > 1) {
              this.options.yAxis.push({
                opposite: true,
                type: 'linear',
                title: {
                  text: 'LifeTime(hrs)',
                  style: {
                    color: "black",
                    fontWeight: 1000
                  }
                },
                gridLineWidth: 0,
                lineColor: 'grey',
                showFirstLabel: true,
                showLastLabel: true,
              })
              this.options.series[1].yAxis = 1;
              this.options.series[1].color = "#FF0000";
            }
          } else {
            this.options.yAxis.push({
              opposite: false,
              type: 'linear',
              title: {
                text: 'LifeTime(hrs)',
                style: {
                  color: "black",
                  fontWeight: 1000
                }
              },
              gridLineWidth: 0,
              lineColor: 'grey',
              showFirstLabel: true,
              showLastLabel: true,
            })
            this.options.series[0].yAxis = 1;
            this.options.series[0].color = "#FF0000"
          }
        }
        let emptyPvList = []
        let failedPvList = []
        
           
            // this.$axios.get(this.urlFragment + "/history/nameMap/" + pvList + "/" + time1 + "/" + time2)
            //this.$axios.get("/hlsTS/history/nameMap/" + pvList  + '/' + " " + "/" + time1 + "/" + time2)
            this.$axios.post("/hlsTS/history/nameMap",{
               pvList: pvList,
               type: " ",        // 保留原来的空字符串
               startTime: time1,
               endTime: time2
            }).then(function (response) {
                _this.options.xAxis.title.text= 'Time';
                if (response.status !== 200) {
                  _this.$confirm("查询失败", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                if (response.data == null || response.data === "" || response.data.length === 0) {
                  _this.$confirm("查询结果为空", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                let data = response.data;
                for (let k = 0; k < checkedPvList.length; k++) {
                  let name = checkedPvList[k][1];
                  //let index = _this.dianping.indexOf(name);
                  let isState = checkedPvList[k][2] == "true" ? true : false;
                  //if(index !== -1){
                  //if(isState){
                  if(data[name].is_state){
                    _this.options.series[k].step = 'left';
                  }else{
                    _this.options.series[k].step = '';
                  }
                  if (data[name].data == null || data[name].data.length == 0) {
                    emptyPvList.push(name);
                    continue;
                  }
                  let p = [];
                  date1.setMilliseconds(0);
                  date2.setMilliseconds(999);
                  if(shijianchuo(data[name].data[0].timestamp.substring(0,13)) <= date1.getTime()){
                    if(data[name].data[0].float_val != null){
                      p.push([date1.getTime(), data[name].data[0].float_val])
                      if (data[name].data[0].float_val != null) {
                        for (let i = 1; i < data[name].data.length -1; i++) {
                          // p.push([data[name][i].smpl_time, data[name][i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].float_val]); 

                        }
                        if(data[name].data.length == 1){
                          let t = date2.getTime() - date1.getTime();
                          p.push([date1.getTime() + t/3 , data[name].data[0].float_val]);
                          p.push([date1.getTime() + t *2/3 , data[name].data[0].float_val]);
                          // p.push([date2.getTime() - t/2, data[name].data[data[name].data.length - 1].float_val]); 
                        }
                      } 
                      p.push([date2.getTime(), data[name].data[data[name].data.length - 1].float_val]);
                    }
                    if(data[name].data[0].num_val != null){
                      p.push([date1.getTime(), data[name].data[0].num_val])
                      if (data[name].data[0].num_val != null) {
                        for (let i = 1; i < data[name].data.length -1; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].num_val]); 

                        }
                        if(data[name].data.length == 1){
                          let t = date2.getTime() - date1.getTime();
                          p.push([date1.getTime() + t/3 , data[name].data[0].num_val]);
                          p.push([date1.getTime() + t *2/3 , data[name].data[0].num_val]);
                          // p.push([date2.getTime() - t/2, data[name].data[data[name].data.length - 1].float_val]); 
                        }
                      } 
                      p.push([date2.getTime(), data[name].data[data[name].data.length - 1].num_val]);
                    }

                     
                  }else if(shijianchuo(data[name].data[0].timestamp.substring(0,13)) > date1.getTime()){
                    if(data[name].data[0].float_val != null){
                      p.push([date1.getTime(), null])
                      if (data[name].data[0].float_val != null && data[name].data.length > 1) {
                        for (let i = 0; i < data[name].data.length; i++) {
                          // p.push([data[name][i].smpl_time, data[name][i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].float_val]); 

                        }
                      } 
                      p.push([date2.getTime(),data[name].data[data[name].data.length-1].float_val]); 
                    }
                    if(data[name].data[0].num_val != null){
                      p.push([date1.getTime(), null])
                      if (data[name].data[0].num_val != null && data[name].data.length > 1) {
                        for (let i = 0; i < data[name].data.length; i++) {
                          // p.push([data[name][i].smpl_time, data[name][i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].num_val]); 

                        }
                      } 
                      p.push([date2.getTime(),data[name].data[data[name].data.length-1].num_val]); 
                    }

                  }
                  
                  _this.options.xAxis.title.text= data[name].data[0].t;
                  // _this.options.series[k].step = 'left';
                   _this.options.series[k].data = p;
                 
                  
                  
                  sum+=_this.options.series[k].data.length
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
            })
        
        
        function shijianchuo(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
        }
        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      queryLive123: function (date1,date2) {
        let sum = 0;
        // if(flag == 'select'){
        //   this.switchValue2 = true;
        // }else{
        //   this.switchValue2 = false;
        // }
        if (this.checkedPvList === null || this.checkedPvList.length === 0) {
          this.$confirm("请选择需要查询的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        if (this.daSourceValue !== "Oracle" && this.ppValue === "") {
          this.$confirm("请选择需要查询的Aggregate Type", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        this.queryDisabled = false;
        this.chartLoading = false;
        this.switchValue1 = false;
        if (this.options.yAxis.length === 2) {
          this.options.yAxis.pop();
        }
        if (this.options.series.length > 0) {
          if (this.options.series[this.options.yAxis.length - 1].name === "BeamCurrent") {
            this.options.series.pop();
          }
        }
        let q = new Array();
        // let date1 = new Date(this.value5[0]);
        // let date2 = new Date(this.value5[1]);
        // let date1 = livedate1;
        // let date2 = livedate2;
        // if(this.switchValue3 && this.timeMin && this.timeMax){
        //   date1 = new Date(this.timeMin);
        //   date2 = new Date(this.timeMax);
        // }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let _this = this;
        let checkedPvList = [];
        for (let i = 0; i < this.checkedPvList.length; i++) {
          checkedPvList.push([this.checkedPvList[i]])
        }
        let pvList = ""
        for (let i = 0; i < checkedPvList.length; i++) {
          let flag = false;
          let pv = "";
          for (let j = 0; j < this.pvList.length; j++) {
            if (this.pvList[j].name === checkedPvList[i][0]) {
              flag = true;
              pv = this.pvList[j].pv;
              pvList = pvList + pv + "@";
              checkedPvList[i].push(pv)
              break;
              
            }
          }
        }
        if( pvList.indexOf("SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai@") != -1){
          pvList.replace(/SR-CW-ADAM-20:Slot7:Channel6:ai,LA-CW-ADAM-11:Slot7:Channel6:ai@/g,"SR-CW-ADAM-20:Slot7:Channel6:ai@LA-CW-ADAM-11:Slot7:Channel6:ai@")
          //checkedPvList.push[['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai'],['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']];
          checkedPvList.push(['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai']);
          checkedPvList.push(['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']);
        }
        if( pvList.indexOf("SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai@") != -1){
          pvList.replace(/SR-CW-ADAM-20:Slot7:Channel7:ai,LA-CW-ADAM-11:Slot7:Channel7:ai@/g,"SR-CW-ADAM-20:Slot7:Channel7:ai@LA-CW-ADAM-11:Slot7:Channel7:ai@")
          //checkedPvList.push[['LinacTunnel-H1','SR-CW-ADAM-20:Slot7:Channel6:ai'],['LinacTunnel-H2','LA-CW-ADAM-11:Slot7:Channel6:ai']];
          checkedPvList.push(['LinacTunnel-T1','SR-CW-ADAM-20:Slot7:Channel7:ai']);
          checkedPvList.push(['LinacTunnel-T2','LA-CW-ADAM-11:Slot7:Channel7:ai']);
        }
        // this.options.series = [];
       
        
        let emptyPvList = []
        let failedPvList = []
        
           
            // this.$axios.get(this.urlFragment + "/history/nameMap/" + pvList + "/" + time1 + "/" + time2)
            //this.$axios.get("/hlsTS/history/nameMap/" + pvList  + '/' + " " + "/" + time1 + "/" + time2)
            this.$axios.post("/hlsTS/history/nameMap",{
               pvList: pvList,
               type: " ",        // 保留原来的空字符串
               startTime: time1,
               endTime: time2
            }).then(function (response) {
                _this.options.xAxis.title.text= 'Time';
                if (response.status !== 200) {
                  _this.$confirm("查询失败", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                if (response.data == null || response.data === "" || response.data.length === 0) {
                  _this.$confirm("查询结果为空", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                let data = response.data;
                for (let k = 0; k < checkedPvList.length; k++) {
                  let name = checkedPvList[k][1];
                  //let index = _this.dianping.indexOf(name);
                  let isState = checkedPvList[k][2] == "true" ? true : false;
                  //if(index !== -1){
                  //if(isState){
                  if(data[name].is_state){
                    _this.options.series[k].step = 'left';
                  }else{
                    _this.options.series[k].step = '';
                  }
                  if (data[name].data == null || data[name].data.length == 0) {
                    emptyPvList.push(name);
                    continue;
                  }
                  let p = [];
                  date1.setMilliseconds(0);
                  date2.setMilliseconds(999);
                  if(shijianchuo(data[name].data[0].timestamp.substring(0,13)) <= date1.getTime()){
                    if(data[name].data[0].float_val != null){
                      p.push([date1.getTime(), data[name].data[0].float_val])
                      if (data[name].data[0].float_val != null) {
                        for (let i = 1; i < data[name].data.length -1; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].float_val]); 

                        }
                        if(data[name].data.length == 1){
                          let t = date2.getTime() - date1.getTime();
                          p.push([date1.getTime() + t/3 , data[name].data[0].float_val]);
                          p.push([date1.getTime() + t *2/3 , data[name].data[0].float_val]);
                          // p.push([date2.getTime() - t/2, data[name].data[data[name].data.length - 1].float_val]); 
                        }
                      } 
                      p.push([date2.getTime(), data[name].data[data[name].data.length - 1].float_val]); 
                    }
                    if(data[name].data[0].num_val != null){
                      p.push([date1.getTime(), data[name].data[0].num_val])
                      if (data[name].data[0].num_val != null) {
                        for (let i = 1; i < data[name].data.length -1; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].num_val]); 

                        }
                        if(data[name].data.length == 1){
                          let t = date2.getTime() - date1.getTime();
                          p.push([date1.getTime() + t/3 , data[name].data[0].num_val]);
                          p.push([date1.getTime() + t *2/3 , data[name].data[0].num_val]);
                          // p.push([date2.getTime() - t/2, data[name][data[name].length - 1].float_val]); 
                        }
                      } 
                      p.push([date2.getTime(), data[name].data[data[name].data.length - 1].num_val]); 
                    }
                    
                  }else if(shijianchuo(data[name].data[0].timestamp.substring(0,13)) > date1.getTime()){
                    if(data[name].data[0].float_val != null){
                      p.push([date1.getTime(), null])
                      if (data[name].data[0].float_val != null && data[name].data.length > 1) {
                        for (let i = 0; i < data[name].data.length; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].float_val]); 

                        }
                      } 
                      p.push([date2.getTime(),data[name].data[data[name].data.length-1].float_val]); 
                    }
                    if(data[name].data[0].num_val != null){
                      p.push([date1.getTime(), null])
                      if (data[name].data[0].num_val != null && data[name].data.length > 1) {
                        for (let i = 0; i < data[name].data.length; i++) {
                          // p.push([data[name].data[i].smpl_time, data[name].data[i].float_val]);
                          let str = data[name].data[i].timestamp;
                          p.push([shijianchuo(str.substring(0,13)),data[name].data[i].num_val]); 

                        }
                      } 
                      p.push([date2.getTime(),data[name].data[data[name].data.length-1].num_val]); 
                    }
                    

                  }
                  
                   _this.options.xAxis.title.text= data[name].data[0].t;
                  // _this.options.series[k].step = 'left';
                  _this.options.series[k].data = p;
                  // _this.$refs.highcharts.chart.series[k].data = p;
                  
                  
                  // sum+=_this.options.series[k].data.length
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
            })
        
        
        function shijianchuo(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
        }
        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      clearInter:function(){
        if(this.timer){
          clearInterval(this.timer);   
        }
      },
      
       
     
    },
    beforeDestroy(){
      if(this.timer){
        clearInterval(this.timer);   
      }
    }
  }
</script>
<style scoped>
  .el-checkbox + .el-checkbox {
    margin-left: 0px;
  }

  .el-checkbox {
    color: #000;
    margin-right: 15px;
  }

  div {
    margin-left: auto;
    margin-right: auto;
    font-size: small;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #000000;
    font-weight: bold;
    padding-right: 8px;
  }
  .custom-pvlist{
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content:space-between;
    height:20px;
    line-height:20px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/page/activePublic/customizedquery.vue